<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
      

        <v-container class="mt-4">
              <v-text-field
            v-model="Address"
            label="Address"
            required
          ></v-text-field>
          <v-text-field
            v-model="firstname"
            :counter="10"
            label="First name"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastname"
            :counter="10"
            label="Last name"
            required
          ></v-text-field>
           <v-text-field
            v-model="PhoneNumber"
            :counter="15"
            label="Phone"
            required
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
// import VueDropify from "vue-dropify";

// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";


export default {
  name: "editusercomponent",
  

  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200, 
        addRemoveLinks: true,
      },
      valid: false,
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      Address:"",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  methods: {},
};
</script>

<style scoped>
.vue-dropzone {
    padding: 0;
    background: transparent;
    border-style: dashed;
}
</style>


